/** Helper function */
export const makeAttribute = (entity: any, isMobile: boolean) => {
  if (entity && typeof entity === 'object' && 'mobile' in entity && 'desktop' in entity) {
    return isMobile ? entity.mobile : entity.desktop;
  }

  return entity;
};
